export default __webpack_public_path__ + "static/media/warning--snowmobiles--g1.d6ea0469.png";